module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Tabs/images/postbattle-tabs-background.c7ac4be0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Tabs/images/postbattle-tabs-background.png
// module id = 3239
// module chunks = 11